import React from 'react';

const CollectionHit = ({hit}) => {
  const {handle, title} = hit;

  const collectionURL = `/collections/${handle}`;

  return <a href={collectionURL}>{title}</a>;
};

export default CollectionHit;
